import {isFeatureEnabled} from 'feature-flags';
import {Separator} from 'platform/components';
import {Heading, Link, Show, Text, VStack} from 'platform/foundation';

import {Trans} from 'react-i18next';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {WhatsAppConnection} from './components/WhatsAppConnection/WhatsAppConnection';
import {WhatsAppSettings} from './components/WhatsAppSettings';

export function WhatsApp() {
  // Until Embedded Signup is rolled out, everyone keeps the manual form; afterwards only
  // support does, through the manual configuration flag.
  const isManualFormVisible =
    !isFeatureEnabled(featureFlags.WHATSAPP_EMBEDDED_SIGNUP) ||
    isFeatureEnabled(featureFlags.WHATSAPP_MANUAL_CONFIGURATION);

  return (
    <SettingsTemplate
      header={{title: i18n.t('page.integrations.labels.whatsApp')}}
      data-testid="integrations-whatsApp-settings"
    >
      <VStack spacing={6}>
        <Text size="small">{i18n.t('page.settings.whatsApp.description1')}</Text>
        <Text size="small">{i18n.t('page.settings.whatsApp.description2')}</Text>
        <Text size="small">
          <Trans
            i18nKey="page.settings.whatsApp.description3"
            components={{
              doclink: (
                <Link
                  size="small"
                  href={i18n.t('page.settings.whatsApp.doclink')}
                  target="_blank"
                />
              ),
            }}
          />
        </Text>
        <Show whenFeatureEnabled={featureFlags.WHATSAPP_EMBEDDED_SIGNUP}>
          <WhatsAppConnection />
        </Show>
        <Show when={isManualFormVisible}>
          <WhatsAppSettings />
        </Show>
        <Separator />
        <Heading size={4}>{i18n.t('page.settings.whatsApp.conditions')}</Heading>
        <Text size="xSmall">{i18n.t('page.settings.whatsApp.description4')}</Text>
        <VStack spacing={1}>
          <Text size="xSmall" color="secondary">
            {i18n.t('page.settings.whatsApp.paymentConditions')}
          </Text>
          <Heading size={4}>{i18n.t('page.settings.whatsApp.charge')}</Heading>
        </VStack>
      </VStack>
    </SettingsTemplate>
  );
}
